export function faviconCdnUrl(cloudName: string, slug: string, pathname: string): string {
	const base = `https://res.cloudinary.com/${cloudName}`;
	const filename = pathname.slice(1);

	if (pathname.endsWith(".ico")) {
		return `${base}/raw/upload/brand/${slug}/${filename}`;
	}

	const publicId = filename.replace(/\.png$/, "");
	return `${base}/image/upload/brand/${slug}/${publicId}`;
}
